import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../banner-list/model/banner-list.constants";
import { createBanner } from "./banner-create.component.service";
import BannerCreateTemplateComponent from "./banner-create-template.component";
import { getBannerInputs } from "../model/banner.modal";
import { PRIMARY_KEY } from "@constants/app.constants";
import { useEffect } from "react";  
import {getBanners} from "../banner-create/banner-create.component.service";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  BANNER_ALERTS: { CREATE_ALERT } 
} = MESSAGES;

const BannerCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formInputs, setFormInputs] = useState([]);
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let bannerPayload = {};
    for (let i = 0; i < values.length; i++) {
      bannerPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const bannerResponse = await createBanner(bannerPayload);

    // INFO : check api response and show relevant alert message
    if (bannerResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: bannerResponse.message })
      );
    }
  };

  const onLoad = async () => {
    const bannerResponse = await getBanners();

    if (bannerResponse.status) {
      const formattedBanners = bannerResponse.data.map((banner) => ({
        name: banner.name,
        value: banner[PRIMARY_KEY], 
      }));

      const formInputData = getBannerInputs(formattedBanners, {});
      setFormInputs(formInputData);
      setFormTriggers({ ...formTriggers, loading: false });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs: getBannerInputs({}),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <BannerCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default BannerCreateComponent;